// extracted by mini-css-extract-plugin
module.exports = {"root":"Filter_root__mtEP8","single-value__label":"Filter_single-value__label__3ggL1","single-value__value":"Filter_single-value__value__hjE0_"};